import { render } from "./HelpHome.vue?vue&type=template&id=c3954878&scoped=true"
import script from "./HelpHome.vue?vue&type=script&lang=js"
export * from "./HelpHome.vue?vue&type=script&lang=js"

import "./HelpHome.vue?vue&type=style&index=0&id=c3954878&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3954878"]])

export default __exports__